import { useRenderMode } from "../picture-render/render-mode-context.tsx";
import type { PictureBuildProviderProps } from "./picture-build-context.tsx";
import { PictureBuildProvider } from "./picture-build-context.tsx";

type BuildWhenRenderModeRequiresPictureBuildProviderProps = Omit<
	PictureBuildProviderProps,
	"enabled"
>;

function BuildWhenRenderModeRequiresPictureBuildProvider({
	children,
	...props
}: BuildWhenRenderModeRequiresPictureBuildProviderProps) {
	const { activeRenderMode } = useRenderMode();
	return (
		<PictureBuildProvider enabled={activeRenderMode !== "source"} {...props}>
			{children}
		</PictureBuildProvider>
	);
}

export { BuildWhenRenderModeRequiresPictureBuildProvider };
